/**
 * Generated by orval v8.16.0 🍺
 * Do not edit manually.
 * FinPath API
 * Backend API programu FinPath (panel admina + aplikacja mobilna).
 * OpenAPI spec version: 0.1.0
 */

export type V1QuizAdminQuestionsListType = typeof V1QuizAdminQuestionsListType[keyof typeof V1QuizAdminQuestionsListType];


export const V1QuizAdminQuestionsListType = {
  pairs: 'pairs',
  singleChoice: 'singleChoice',
  trueFalse: 'trueFalse',
} as const;
